

export default {
  name: "colorPicker",
  props: {
  },
  mounted() {
    let t = this;

    const pickr = Pickr.create({
      el: '.color-picker',
      theme: 'nano', // or 'monolith', or 'nano'
      useAsButton: true,
      inline: true,
      showAlways: true,
      components: {
        preview: false,
        hue: true,
        interaction: {
          input: true,
        }
      }
    });

    window.__pickrInst = pickr;

    pickr.on('change', (color, source, instance) => {
      let v = color.toHEXA().toString();
      if (t.color == v) {
        return;
      }
      t.color = v;
      if (t.ignoreOnce) {
        t.ignoreOnce = false;
      }
      else {
        t.$emit('change', v);
      }
    });

    if (t.color) {
      t.ignoreOnce = true;
      pickr.setColor(t.color);
    }

  },
  created() {

    let t = this;

    let colors = localStorage['preset_colors'] || '';

    if (colors) {
      colors = colors.split(',');
      colors.forEach(color => {
        t.list.color.push(color);
      });
    }
    else {
      t.list.presetColor.forEach(color => {
        t.list.color.push(color);
      });
    }

  },
  activated: function (el) {
  },
  deactivated() {
  },
  methods: {
    resetColors() {
      let t = this;

      t.list.color.clear();

      t.list.presetColor.forEach(color => {
        t.list.color.push(color);
      });

      localStorage['preset_colors'] = '';
    },
    setColor(color) {
      this.color = color;
      this.ignoreOnce = true;
      __pickrInst.setColor(color);
    },
    addColor() {
      let t = this;

      let color = __pickrInst.getColor().toHEXA().toString();

      if (t.list.color.indexOf(color) == -1) {
        t.list.color.push(color);
      }

      let arr = t.list.color.unique();

      localStorage['preset_colors'] = arr.join(',');
    },
    pickColor(color) {
      this.ignoreOnce = true;
      __pickrInst.setColor(color);
      this.color = color;
      this.$emit('change', color);
    },
  },
  data() {
    return {
      showPalette: false,
      ignoreOnce: false,
      color: '',
      list: {
        color: [],
        presetColor: [
          '#FF4D4D',
          '#FCA000',
          '#F4EA00',
          '#9EC700',
          '#009825',
          '#009E9F',
          '#189CFF',
          '#0072B6',
          '#0016E3',
          '#B400BB',
          '#FF00B9',
          '#000000'
        ],
      }
    };
  },
};
